import { useEffect } from "react"
import { Grid, IMSPolicy } from "../components"
import { Navbar, Footer } from "../layouts"




const IMS = () => {
    useEffect(() => {
        window.scrollTo({
            top: 0, 
            behavior: 'smooth'
          });
    }, [])

    return (
        <>
        <Navbar/>
        <Grid/>
        <IMSPolicy/>
        <Footer/>
        </>

    )
}

export default IMS